import globalStore from '$$globalStore';

export default function (instance, ganttData) {
  instance.ganttDataApi.isBase = () => globalStore.getters.isBase;
  instance.ganttDataApi.isExport = () => globalStore.getters.isExport;
  instance.ganttDataApi.isLink = () => globalStore.getters.isLink;
  instance.ganttDataApi.isHistory = () => globalStore.getters.isHistory;

  instance.ganttDataApi.getWindowParams = () => globalStore.getters.getWindowParams;
  instance.ganttDataApi.getLeftSidebarWidth = () => globalStore.getters.leftSidebarWidth;
  instance.ganttDataApi.getShowGrid = () => globalStore.getters.getShowGrid;

  // filter
  instance.ganttDataApi.getCurrentFilter = () => globalStore.getters['filter/currentFilter'];
  instance.ganttDataApi.isFilterActive = () => globalStore.getters['filter/isActive'];
  instance.ganttDataApi.setFilterIsNotFound = flag => globalStore.commit('filter/setIsNotFound', flag);

  // mass change
  instance.ganttDataApi.getMassChangeSelectedItems = () => globalStore.getters['massChange/selectedItems'];
  instance.ganttDataApi.isMassChangeEnabled = () => globalStore.getters['massChange/isEnabled'];

  // team settings
  instance.ganttDataApi.getCurrency = () => globalStore.getters['teamSetting/currency'];
  instance.ganttDataApi.isCurrencyEnabled = () => globalStore.getters['teamSetting/enableCurrency'];

  // comments
  instance.ganttDataApi.getTaskCommentsMetaData = taskId => globalStore.state.comments?.taskCommentsMetaData?.[taskId];

  // baselines
  instance.ganttDataApi.getBaselineData = options => globalStore.dispatch('baselines/getBaselineData', options);

  // user
  instance.ganttDataApi.getUserActivitySettings = activityName => globalStore.getters['user/getActivitySettings'](activityName);
  instance.ganttDataApi.updateUserActivityStatus = options => globalStore.dispatch('user/updateActivityStatus', options);

  // history
  instance.ganttDataApi.openHistoryWindow = () => globalStore.dispatch('headerView/openHistoryWindow');
}
